import React from 'react';
import Oy from 'oy-vey';
import { IntlProvider } from 'react-intl';
import fetch from '../fetch';
import EmailTemplate from './template/EmailTemplate';
import { getSubject } from './template/subjects';
import { getConfigData } from '../../helpers/getConfigData';

export async function sendEmail(to, type, content) {

    const emailData = await getConfigData({ name: ['siteName'] });
    // Always use relative URL to avoid /user/undefined/graphql issue
    let apiUrl = '';
    if (typeof window === 'undefined') {
        apiUrl = `http://localhost:${process.env.PORT || 3000}`;
    }
    let html;
    let subjectData = getSubject(type, content), emailContent = content;
    emailContent.siteName =
        (emailData && emailData.siteName && emailData.siteName.trim()) || 'MotoStream';

    // Extra check in case it's still undefined or blank
    if (emailContent.siteName === undefined || emailContent.siteName.trim?.() === '') {
        emailContent.siteName = 'MotoStream';
    }
    console.log(`[Value Used] siteName: ${emailContent.siteName}`);

    let query = `query getEmailLogo {
        getEmailLogo { 
          name
          value
        }
      }`;

    if (content && !content.logo) {
        const logoResp = await fetch(`${apiUrl}/graphql`, {
            method: 'post',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                query
            }),
            credentials: 'include',
        });

        const { data } = await logoResp.json();
        emailContent.logo = data && data.getEmailLogo && data.getEmailLogo.value;
        if (emailContent.logo === undefined || emailContent.logo.trim?.() === '') {
            emailContent.logo = '4ef37f928434c0228ff16c94aa43880e.png';
        }

    }
    console.log(`[Value Used] logo: ${emailContent.logo}`);
    console.log(emailContent, "emailContent")

    html = Oy.renderTemplate(
        <IntlProvider locale={"en"}>
            <EmailTemplate type={type} content={emailContent} />
        </IntlProvider>, {
        title: subjectData.subject,
        previewText: subjectData.previewText
    });


    let mailOptions = {
        to, // list of receivers
        subject: subjectData.subject, // Subject line
        //text: textMessage, // plain text body
        html
    };

    console.log(mailOptions, "mailOptions")

    const resp = await fetch(`${apiUrl}/sendEmail`, {
        method: 'post',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ mailOptions }),
        credentials: 'include'
    });
    const { status, response } = await resp.json();
    return { status, response };
} 
